import Button from '@alltrails/shared/denali/components/Button';

export type FormButtonProps = {
  value: string;
  className?: string;
  disabled?: boolean;
  width?: 'auto' | 'full'; // TODO: DS-91 consolidate types
};

const FormButton = ({ value, disabled, className, width = 'full' }: FormButtonProps) => (
  <Button
    text={value}
    className={className}
    disabled={disabled}
    onClick={() => {
      /* do nothing - forms should handle submit */
    }}
    testId="formButton-submit"
    type="submit"
    variant="primary"
    width={width}
  />
);

export default FormButton;
